<div class="users-list">
  @for (user of users(); track user.userId) {
    <div class="user-card">
      <div class="user-card__header">
        <lib-or-avatar
          [avatarUrl]="user.thumbnailUrl"
          [initials]="user.name + ' ' + user.lastName"
          [rightMargin]="false"
          avatarSize="sm">
        </lib-or-avatar>

        <div class="user-card__info">
          <div class="user-card__name">{{ user.name }} {{ user.lastName }}</div>
          <div class="user-card__email">{{ user.email }}</div>
          @if (user.regionName) {
            <div class="user-card__region">{{ user.regionName }}</div>
          }
        </div>

        <button class="user-card__action" (click)="sendMessage(user, $event)">
          <or-icon name="contact" size="s" boxed class="or-color-white or-bg-main-1" />
        </button>

        <button class="user-card__action" (click)="moderateUser(user, $event)">
          <or-icon name="dots-vertical" size="s" boxed />
        </button>
      </div>

      <div class="user-card__meta">
        <div class="meta-item">
          <span class="meta-item__label">Wersja</span>
          <span class="meta-item__value">
            @if (user.platform === 'android') {
              <img src="assets/icons/android.svg" class="platform-icon" />
            } @else if (user.platform === 'ios') {
              <img src="assets/icons/apple.svg" class="platform-icon" />
            } @else if (user.platform === 'mobileweb' || user.platform === 'web') {
              <img src="assets/icons/bottom-navbar/bottom-find-games.svg" class="platform-icon" />
            }
            {{ user.versionInfo }}
          </span>
        </div>
        <div class="meta-item">
          <span class="meta-item__label">Rejestracja</span>
          <span class="meta-item__value">{{ user.formattedRegisterDate }}</span>
          <span class="meta-item__sub">{{ user.formattedRegisterTime }}</span>
        </div>
        <div class="meta-item meta-item--stats">
          <span class="meta-item__label">H/G/A</span>
          <span class="meta-item__value"
            >{{ user.stats.hostedGames }}/{{ user.stats.playedGames }}/{{ user.stats.gameApplications }}</span
          >
        </div>
      </div>

      <div class="user-card__actions">
        <button class="action-btn action-btn--primary" (click)="goToProfile(user.userId)">Profil</button>
        <button class="action-btn" [copyToClipboard]="user.userId">ID</button>
      </div>
    </div>
  }
</div>
